import { useState } from 'react';



import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = ({ onSearch }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCity, setSelectedCity] = useState('manila');

  const philippineCities = [
  { value: 'manila', label: 'Manila' },
  { value: 'quezon-city', label: 'Quezon City' },
  { value: 'caloocan', label: 'Caloocan' },
  { value: 'davao', label: 'Davao City' },
  { value: 'cebu', label: 'Cebu City' },
  { value: 'zamboanga', label: 'Zamboanga City' },
  { value: 'taguig', label: 'Taguig' },
  { value: 'antipolo', label: 'Antipolo' },
  { value: 'pasig', label: 'Pasig' },
  { value: 'cagayan-de-oro', label: 'Cagayan de Oro' },
  { value: 'makati', label: 'Makati' },
  { value: 'paranaque', label: 'Parañaque' }];

  const handleSearch = () => {
    onSearch({ query: searchQuery, city: selectedCity });
  };

  return (
    <section className="relative bg-gradient-to-br from-[#1E73BE] via-[#2A85D8] to-[#1E73BE] pt-[20px] lg:pt-[25px] pb-[20px] lg:pb-[25px] overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_18f526c19-1770463447834.png"
          alt="Filipino workers and professionals in traditional and modern work settings showcasing Filipino culture and way of living"
          className="w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1E73BE]/50 via-[#2A85D8]/50 to-[#1E73BE]/50" />
      </div>
      
      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-96 h-96 bg-[#FF6A00]/10 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#5CD600]/10 rounded-full blur-3xl" />
      </div>
      
      <div className="relative max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 items-center">
          {/* Left Content */}
          <div>
            {/* Trust Badge */}
            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 backdrop-blur-md rounded-full mb-4 border border-white/40 bg-white/20 ml-0">
              <div className="w-4 h-4 bg-[#FF6A00] rounded-full flex items-center justify-center">
                <Icon name="Check" size={12} color="#FFFFFF" className="bg-transparent border-0" />
              </div>
              <span className="text-white font-semibold text-[10px]">Verified & Trusted Platform</span>
            </div>

            {/* Heading */}
            <h1 className="md:text-3xl lg:text-4xl text-white mb-4 text-center text-[28px] font-black">
              Your <span className="font-black text-[rgba(254,121,32,1)] border-white border-0 [text-shadow:_-1px_-1px_0_#fff,_1px_-1px_0_#fff,_-1px_1px_0_#fff,_1px_1px_0_#fff]">DISKARTE</span> to Success Starts Here
            </h1>

            {/* Description */}
            <p className="text-gray-200 mb-5 max-w-[600px] text-center text-xs">
              Connect with verified side hustlers or find your next gig. From plumbing to tutoring, DISKARTE bridges the gap between skilled Filipinos and those who need their services.
            </p>

            {/* Search Bar - 30% smaller */}
            <div className="bg-white rounded-xl shadow-[0_6px_18px_rgba(0,0,0,0.06)] p-1 mt-[8px] mb-[16px]">
              <div className="flex flex-col sm:flex-row gap-1">
                <div className="flex-1 flex items-center gap-1 px-2">
                  <Icon name="Search" size={14} color="#6B7280" />
                  <input
                    type="text"
                    placeholder="What service do you need?"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e?.target?.value)}
                    className="flex-1 py-1.5 text-xs outline-none text-gray-800 placeholder:text-gray-400" />
                </div>
                <div className="flex items-center gap-1">
                  <div className="flex-1 sm:flex-none sm:w-[120px] px-2 py-1.5 border-t sm:border-t-0 sm:border-l border-gray-200">
                    <div className="flex items-center gap-1">
                      <Icon name="MapPin" size={14} color="#6B7280" />
                      <select
                        value={selectedCity}
                        onChange={(e) => setSelectedCity(e?.target?.value)}
                        className="flex-1 outline-none text-gray-800 bg-transparent cursor-pointer text-xs">
                        <option value="">All Locations</option>
                        {philippineCities?.map((city) =>
                        <option key={city?.value} value={city?.value}>{city?.label}</option>
                        )}
                      </select>
                    </div>
                  </div>
                  <Button
                    onClick={handleSearch}
                    className="bg-[#FF6A00] hover:bg-[#FF7A1A] text-white px-4 py-1.5 rounded-lg font-semibold shadow-md text-[10px]">
                    Search
                  </Button>
                </div>
              </div>
            </div>

            {/* Popular Services */}
            <div className="flex flex-wrap items-center gap-2">
              <span className="text-gray-300 text-[10px]">Popular:</span>
              {['Plumber', 'Driver', 'Cleaner', 'Tutor']?.map((service) =>
              <button
                key={service}
                onClick={() => setSearchQuery(service)}
                className="px-3 py-1 bg-[#1E73BE]/40 hover:bg-[#2A85D8]/50 backdrop-blur-sm border border-[#2A85D8]/30 rounded-full text-white transition-all text-[10px]">
                  {service}
                </button>
              )}
            </div>
          </div>

          {/* Right Stats Grid - Reduced holder by 30% and icons 30% smaller */}
          <div className="grid grid-cols-2 gap-2">
            {/* Stat Card 1 */}
            <div className="bg-[#2A85D8]/40 backdrop-blur-lg rounded-2xl p-2 border border-white/30 hover:bg-[#2A85D8]/50 transition-all ml-3 shadow-lg">
              <div className="w-[42px] h-[42px] bg-[#FF6A00] rounded-xl flex items-center justify-center mb-2">
                <Icon name="Users" size={42} color="#FFFFFF" />
              </div>
              <div className="text-xl font-bold text-white mb-0.5">50,000+</div>
              <div className="text-[10px] text-white">Verified Side Hustlers</div>
            </div>

            {/* Stat Card 2 */}
            <div className="bg-[#2A85D8]/40 backdrop-blur-lg rounded-2xl p-2 border border-white/30 hover:bg-[#2A85D8]/50 transition-all mx-2 shadow-lg">
              <div className="w-[42px] h-[42px] bg-[#1E73BE] rounded-xl flex items-center justify-center mb-2">
                <Icon name="Briefcase" size={42} color="#FFFFFF" />
              </div>
              <div className="text-xl font-bold text-white mb-0.5">120,000+</div>
              <div className="text-[10px] text-white">Jobs Completed</div>
            </div>

            {/* Stat Card 3 */}
            <div className="bg-[#2A85D8]/40 backdrop-blur-lg rounded-2xl p-2 border border-white/30 hover:bg-[#2A85D8]/50 transition-all ml-3 shadow-lg">
              <div className="w-[42px] h-[42px] bg-[#5CD600] rounded-xl flex items-center justify-center mb-2">
                <Icon name="Shield" size={42} color="#FFFFFF" />
              </div>
              <div className="text-xl font-bold text-white mb-0.5">98%</div>
              <div className="text-[10px] text-white">Satisfaction Rate</div>
            </div>

            {/* Stat Card 4 */}
            <div className="bg-[#2A85D8]/40 backdrop-blur-lg rounded-2xl p-2 border border-white/30 hover:bg-[#2A85D8]/50 transition-all mx-2 shadow-lg">
              <div className="w-[42px] h-[42px] bg-[#66E000] rounded-xl flex items-center justify-center mb-2">
                <Icon name="MapPin" size={42} color="#FFFFFF" />
              </div>
              <div className="text-xl font-bold text-white mb-0.5">75+</div>
              <div className="text-[10px] text-white">Cities Covered</div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;